import React from 'react';
import { getContributorAvatar } from 'common/constants/Avatars';
import { extractAlertsFromBranch } from 'common/services/graphql.service';
import { getGraphItemsData } from '../../pulse.service';
import { BranchNameColumn, LastActivityColumn } from './columns';
import MultipleAvatars from 'components/MultipleAvatars';
import IterationGraph from '../IterationGraph/IterationGraph';
import StuckCol from '../StuckCol';

const withUnmatchedBranchesData = WrappedComponent => props => {
  const {
    data,
    selectedContributorIds,
    contributorsById,
    contributors,
    myAccount
  } = props;
  const formattedData = !data
    ? []
    : data.map(item => {
        const avatars = item.contributor_ids.map(id =>
          getContributorAvatar({ id, selectedContributorIds })
        );
        const graphItems = getGraphItemsData(
          [item],
          contributors,
          selectedContributorIds
        );

        const alerts = extractAlertsFromBranch(item, contributors);

        return {
          key: item.name,
          branch: (
            <BranchNameColumn
              name={item.name.replace('origin/', `${item.repository_name}/`)}
              state={item.state}
              date={item.first_committed_at}
              pullRequest={item.pull_request}
              httpUrl={item.http_url}
            />
          ),
          people: <MultipleAvatars avatars={avatars} size='2.5rem' />,
          lastActivity: (
            <LastActivityColumn
              lastActivity={item.last_activity || {}}
              contributorsById={contributorsById}
              myAccount={myAccount}
            />
          ),
          timeline: (
            <IterationGraph
              carryover={item.carryOver}
              items={graphItems}
              hasAlerts={alerts.length}
              isStoryGraph={false}
              selectedContributorIds={selectedContributorIds}
            />
          ),
          stuck: <StuckCol alerts={alerts} />
        };
      });

  return <WrappedComponent {...props} data={formattedData} />;
};

export default withUnmatchedBranchesData;
